"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decamelize = exports.camelize = void 0;
var lodash_es_1 = require("lodash-es");
var CaseEnum;
(function (CaseEnum) {
    CaseEnum["Camel"] = "camelCase";
    CaseEnum["Snake"] = "snakeCase";
})(CaseEnum || (CaseEnum = {}));
var converters = {
    camelCase: lodash_es_1.camelCase,
    snakeCase: lodash_es_1.snakeCase,
};
var isRegExp = function (obj) { return obj instanceof RegExp; };
var isCamelCase = function (str) { return str === lodash_es_1.camelCase(str); };
function core(target, options) {
    var style = options.style, _a = options.recursive, recursive = _a === void 0 ? false : _a, excludes = options.excludes, exception = options.exception, _b = options.force, force = _b === void 0 ? false : _b;
    var isExclude = (function () {
        if (Array.isArray(excludes)) {
            return function (key) { return excludes.includes(key); };
        }
        if (isRegExp(excludes)) {
            return function (key) { return excludes.test(key); };
        }
        if (typeof excludes === 'function') {
            return excludes;
        }
        return function () { return false; };
    })();
    var convert = (function () {
        var convertFn = converters[style];
        if (excludes) {
            return function (key) { return isExclude(key) ? key : convertFn(key); };
        }
        if (exception) {
            return function (key) {
                var value = exception[key];
                if (value) {
                    return typeof value === 'function' ? value(key) : value;
                }
                return force || isCamelCase(key) ? convertFn(key) : key;
            };
        }
        return function (key) { return force || isCamelCase(key) ? convertFn(key) : key; };
    })();
    var isRecursive = (function () {
        if (typeof recursive === 'object' && Array.isArray(recursive.excludes)) {
            return function (key) { return !isExclude(key) && !recursive.excludes.includes(key); };
        }
        if (recursive === true) {
            return function (key) { return !isExclude(key); };
        }
        return function () { return false; };
    })();
    var mapObject = function (obj) {
        if (!obj || (typeof obj !== 'object')) {
            return obj;
        }
        if (Array.isArray(obj)) {
            return obj.map(function (o) { return mapObject(o); });
        }
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            return Object.entries(obj).reduce(function (result, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return Object.assign(result, (_b = {},
                    _b[convert(key)] = isRecursive(key) ? mapObject(value) : value,
                    _b));
            }, {});
        }
        return obj;
    };
    return mapObject(target);
}
function camelize(target, options) {
    if (options === void 0) { options = {}; }
    return core(target, Object.assign({ style: CaseEnum.Camel, force: true }, options));
}
exports.camelize = camelize;
function decamelize(target, options) {
    if (options === void 0) { options = {}; }
    return core(target, Object.assign({ style: CaseEnum.Snake }, options));
}
exports.decamelize = decamelize;



// WEBPACK FOOTER //
// /static/packages/object-case-converter/dist/camelize.js